module.exports = __webpack_public_path__ + "img/chevron-secondary.22ffe50a.svg";